import { render, staticRenderFns } from "./detailsFacture.vue?vue&type=template&id=28e87694&"
import script from "./detailsFacture.vue?vue&type=script&lang=js&"
export * from "./detailsFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports